var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.133 0.0126953L16.3163 1.19603L11.5497 5.95436C12.4413 7.2377 12.5663 8.77936 11.8163 9.77936L6.54967 4.51269C7.54967 3.76269 9.09134 3.88769 10.3747 4.77936L15.133 0.0126953ZM3.94134 12.3877C2.26634 10.7127 1.24134 8.7127 0.958008 6.84603L5.02467 5.10436L11.2247 11.3044L9.48301 15.371C7.61634 15.0877 5.61634 14.0627 3.94134 12.3877Z",
    fill: "#547192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetIcon);
export default __webpack_public_path__ + "static/media/SetIcon.2a4a98435fe816c2ec1a1f1c6637c220.svg";
export { ForwardRef as ReactComponent };